import { TasksIndex } from "@/pages/tasks/TasksIndex.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";
import { ApiPermission } from "@/types/role.types.ts";

export const tasksRoutes: RouteConfig[] = [
  {
    path: "/tasks",
    planFeature: ApiFeatureType.tasks,
    allOfPermissions: [ApiPermission.tasks_module],
    isHideSidebar: true,
    children: [
      {
        path: ":section?",
        isHideSidebar: true,
        element: <TasksIndex />,
      },
    ],
  },
];
